import { MergerRecord, MergerStatus } from '../types';

export const STATUS_STYLE_MAP: Record<
  MergerRecord['status'],
  { bg: string; color: string; label: string }
> = {
  DRAFT: { bg: 'gray.700', color: 'gray.200', label: 'Draft' },
  PENDING: { bg: 'yellow.700', color: 'white', label: 'Pending' },
  EXECUTING: { bg: 'blue.500', color: 'white', label: 'Executing' },
  EXECUTED: { bg: 'green.700', color: 'white', label: 'Executed' },
  DECLINED: { bg: 'red.900', color: 'white', label: 'Declined' },
};

export const ACTIVE_MERGE_STATUSES: MergerStatus[] = [
  'DRAFT',
  'PENDING',
  'EXECUTING',
];
export const COMPLETED_MERGE_STATUSES: MergerStatus[] = [
  'EXECUTED',
  'DECLINED',
];

export const MERGER_ACTION = {
  OPEN: 'open',
  MERGE: 'merge',
  RESEND: 'resend',
  DELETE: 'delete',
} as const;

export type MergerActionType = typeof MERGER_ACTION[keyof typeof MERGER_ACTION];

export interface ActiveMergerAction {
  mergerId: number;
  action: MergerActionType;
}
